<script>
import FirstLanding from '../components/FirstLanding.svelte'
import AboutMe from '../components/AboutMe.svelte'
import Work from '../components/Work.svelte'

</script>
<style>

 .container{
     background-color: black;
     overflow: hidden;
 }   
</style>
<div class="container">
<FirstLanding/>
<AboutMe/>
<Work/>
</div>